export enum EaTabIndex {
    TilFramkvaemdar = 0,
    Loknar = 1,
    Allar = 2,
    Eigandi = 3,
}

// Should match JiraEaViewMode values on backend
export enum JiraEaViewMode {
    Default = 0,
    ImplementerNonYfirmal = 1,
    ImplementerYfirmal = 2,
    OwnerYfirmal = 3,
}

export type StatusFilterMode = 'all' | 'open' | 'closed';

export const GrantsTypes = {
    Year: 'Ár',
    Fitness: 'Íþróttastyrkur',
    Vision: 'Gleraugnastyrkur',
    Phone: 'Símastyrkur'
}
